import {DomElement,getAlarmColor,convert2d3d} from '../../types/datatypes'


class TableElement extends DomElement{
  createContent(data){
    var  content=''
    if(!Array.isArray(data)||data.length==0){return content}

    data.forEach(e=>{
          var color="#ffffff"
          if(e.hasOwnProperty('alarm')){
            color=getAlarmColor(e.alarm)
          }
          content+=`<div class="devider  padding-tb-sm text-left" style="color:`+color+`"><span class="margin-right">`+e.name+`</span><span style="font-weight:bold;">`+e.value+`<span class="text-xs">`+e.unit+`</span></span></div>`;
    });
    return content
  }
  createDom(){
    var container=this.createContainer()
    var content=''
    var linecolor='rgba(255,255,255,.4)'
    if(this.params.value&&Array.isArray(this.params.value)){
      content=this.createContent(this.params.value)
    }
    var html=`
          <div class="content-container" style="border-color:`+linecolor+`!important;font-size:.8em">
            <div class=" padding-sm"><div class="padding-bottom-sm title">`+this.params.name+`</div><div class="text-xs sub">`+this.params.sub+`</div></div>

            <div class="content">`+content+`</div>
          </div>
          <div  class="line" style="background:`+linecolor+`"></div>
          `
    container.innerHTML=html
    return container
  }
  update(mesh,d){
    const createContent=(data)=>{
        var  content=''
          if(!Array.isArray(data)||data.length==0){return content}

          data.forEach(e=>{
                var color="#ffffff"
                if(e.hasOwnProperty('alarm')){
                  color=getAlarmColor(e.alarm)
                }
                content+=`<div class="devider  padding-tb-sm text-left" style="color:`+color+`"><span class="margin-right">`+e.name+`</span><span style="font-weight:bold;">`+e.value+`<span class="text-xs">`+e.unit+`</span></span></div>`;
          });
          return content
    }
    mesh.userData.params=Object.assign(mesh.userData.params,d)
    mesh.element.querySelector('.title').innerHTML=mesh.userData.params.name
    mesh.element.querySelector('.sub').innerHTML=mesh.userData.params.sub
    if(data.value){
        mesh.element.querySelector('.content').innerHTML=createContent(data.value)
    }
  }
}

const dom=new TableElement('table','表格')
dom.params={
  name:'',
  sub:'',
  value:[],
  use3d:true,
  setting:['data','xyz']
}
dom.format={
  name:{name:'名称',change(mesh,v){
    mesh.element.querySelector('.title').innerHTML=v
  }},
  sub:{name:'描述',change(mesh,v){
    mesh.element.querySelector('.sub').innerHTML=v
  }},
  use3d:{name:'3d对象',domtype:'switch',change(mesh,v){
             convert2d3d(mesh,v)
   }}
}
export default dom
